/**
 * Calcule l'impact business mensuel à partir des stats du dashboard.
 * Réutilise la formule centrale du backend (backend/routes/dashboard.js).
 *
 * @param {Object} stats - data.stats (satisfaits, feedbacks_negatifs)
 * @param {number} ticket_moyen - data.restaurant.ticket_moyen (en €)
 * @returns {Object} { couverts_supp, ca_genere, perte_evitee, roi_total }
 */
export function calculImpactBusiness(stats, ticket_moyen) {
  const ticket = Number(ticket_moyen) || 0;
  const satisfaits = stats?.satisfaits || 0;
  const feedbacks_negatifs = stats?.feedbacks_negatifs || 0;

  // 30% des clients satisfaits génèrent un nouveau couvert via avis Google
  const couverts_supp = Math.round(satisfaits * 0.3);
  const ca_genere = couverts_supp * ticket;

  // Chaque feedback négatif intercepté = 3 clients potentiels préservés
  const perte_evitee = feedbacks_negatifs * ticket * 3;

  const roi_total = ca_genere + perte_evitee;

  return {
    couverts_supp,
    ca_genere: Math.round(ca_genere),
    perte_evitee: Math.round(perte_evitee),
    roi_total: Math.round(roi_total),
  };
}

/**
 * Formate un montant en euros pour affichage.
 * @param {number} amount - Montant en euros
 * @param {boolean} withPlus - Préfixe + pour les valeurs positives
 * @returns {string} Ex: "+1 250 €" ou "0 €"
 */
export function formatEuros(amount, withPlus = false) {
  const prefix = withPlus && amount > 0 ? '+' : '';
  return `${prefix}${amount.toLocaleString('fr-FR')} €`;
}
